var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import "../types.js";
import { registerSystem, DEPTHS } from "../ComponentRegistry.js";
import { EntityFactory } from "../../entity/EntityFactory.js";
import { O as OwnerSchema } from "../../Owner-4cb1d33a.js";
import { S as SpawnOnTimeoutSchema, M as MultiSpawnOnTimeoutSchema } from "../../SpawnOnTimeoutComponent-0dd66b5e.js";
import { C as ComponentCategory } from "../../enums-86f58524.js";
import "../../decorators/type.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../global-33d5eebf.js";
import "../../utils/byteArray.js";
import "../../constants/index.js";
import "../../loader/AssetLoader.js";
import "../../loader/ImageLoader.js";
import "pixi.js";
import "../../loader/SpriteLoader.js";
import "../../loader/PixiSpriteLoader.js";
import "../../loader/MapLoader.js";
import "../../utils/colors.js";
import "../../utils/sharedFetch.js";
import "../../vendor/noise/index.js";
import "url";
import "@dimforge/rapier2d-compat";
import "../../persist/persist.js";
import "../../loader/PixiSpineLoader.js";
import "pixi-spine";
import "../../loader/SoundLoader.js";
import "../../_commonjsHelpers-7a77ea84.js";
import "toposort";
import "lodash";
import "../../Parent-b4f1af10.js";
import "../core/ListenEntityCreation.js";
import "../entity/Spawn.js";
class SpawnOnTimeoutSystem {
  constructor() {
    __publicField(this, "type", "SpawnOnTimeout");
    __publicField(this, "category", ComponentCategory.BEHAVIOR);
    __publicField(this, "schema", SpawnOnTimeoutSchema);
    __publicField(this, "depth", DEPTHS.HEALTH + 1);
  }
  run(entity, gameModel) {
    const data = gameModel.getTypedUnsafe(entity, SpawnOnTimeoutSchema);
    updateTimeout(entity, data, gameModel);
  }
}
registerSystem(SpawnOnTimeoutSystem);
function updateTimeout(entity, timeout, gameModel) {
  timeout.timeElapsed += gameModel.dt(entity);
  if (timeout.timeElapsed > timeout.timeout && !timeout.timedOut) {
    if (timeout.spawn.length > 0) {
      let owner = entity;
      if (gameModel.hasComponent(entity, "Owner")) {
        owner = gameModel.getTypedUnsafe(entity, OwnerSchema).owner ?? entity;
      }
      timeout.spawn.forEach((spawn) => {
        const spawnedEntity = EntityFactory.getInstance().generateEntity(gameModel, spawn.description, {
          SourceStats: {
            damageAmount: 0,
            source: entity,
            owner
          }
        });
        if (spawn.overrideComponents.length > 0) {
          for (let i = 0; i < spawn.overrideComponents.length; i++) {
            const override = spawn.overrideComponents[i];
            if (override.type === "SourceStats") {
              gameModel.addComponent(spawnedEntity, override.type, {
                damageAmount: 0,
                source: entity,
                owner
              });
            } else {
              let overrideData = override.data;
              if (override.inherit) {
                overrideData = { ...gameModel.getComponent(spawnedEntity, override.type), ...overrideData ?? {} };
              }
              gameModel.addComponent(spawnedEntity, override.type, overrideData);
            }
          }
        }
      });
    }
    timeout.timedOut = true;
  }
}
class MultiSpawnOnTimeoutSystem {
  constructor() {
    __publicField(this, "type", "MultiSpawnOnTimeout");
    __publicField(this, "category", ComponentCategory.BEHAVIOR);
    __publicField(this, "schema", MultiSpawnOnTimeoutSchema);
    __publicField(this, "depth", DEPTHS.HEALTH + 1);
  }
  run(entity, gameModel) {
    const data = gameModel.getTypedUnsafe(entity, MultiSpawnOnTimeoutSchema);
    for (let i = 0; i < data.timeouts.length; ++i) {
      const timeout = data.timeouts[i];
      updateTimeout(entity, timeout, gameModel);
      if (timeout.timedOut) {
        data.timeouts.splice(i, 1);
        i--;
      }
    }
    if (data.timeouts.length === 0) {
      gameModel.removeComponent(entity, "MultiSpawnOnTimeout");
    }
  }
}
registerSystem(MultiSpawnOnTimeoutSystem);
const addToSpawnOnTimeout = (entity, timeout, gameModel, spawnOnTimeout = [], applyOnTimeout = []) => {
  if (!gameModel.hasComponent(entity, "SpawnOnTimeout")) {
    gameModel.addTyped(entity, SpawnOnTimeoutSchema, {
      timeout,
      timeElapsed: 0,
      spawn: spawnOnTimeout
    });
    return;
  }
  if (!gameModel.hasComponent(entity, "MultiSpawnOnTimeout")) {
    gameModel.addComponent(entity, "MultiSpawnOnTimeout", {
      timeouts: [
        {
          timeout,
          timeElapsed: 0,
          spawn: spawnOnTimeout
        }
      ]
    });
    return;
  }
  const data = gameModel.getTypedUnsafe(entity, MultiSpawnOnTimeoutSchema);
  const spawnString = JSON.stringify(spawnOnTimeout);
  const prevIndex = data.timeouts.findIndex((t) => JSON.stringify(t.spawn) === spawnString);
  if (prevIndex === -1) {
    const SpawnOnTimeout = {
      timeout,
      timedOut: false,
      timeElapsed: 0,
      spawn: spawnOnTimeout
    };
    data.timeouts.push(SpawnOnTimeout);
  } else {
    data.timeouts[prevIndex].timeout = timeout;
    data.timeouts[prevIndex].timeElapsed = 0;
  }
};
export {
  addToSpawnOnTimeout
};
//# sourceMappingURL=SpawnOnTimeout.js.map
